<template lang="pug">
  .b-project-file-category-frame(
    @click="$emit('click')"
    :class="{ active, dragEntered, isEditable }"
    @dragover.prevent="fileDragEnter"
    @dragleave="fileDragLeave"
    @drop.prevent="fileDrop"
  )
    ._common
      ._name {{ fileCategoryData.name.slice(0, 20) }}
      ._length {{ filesWord }}
    ._menu(@click.stop)
      EllipsisMenu(v-if="isEditable" :items="menuItems")
    ._size {{ filesStorageSize.toUpperCase() }}

</template>

<script>
import utils from '@/utils/common';
import EllipsisMenu from '@/components/EllipsisMenu.vue';

export default {
  name: 'ProjectFileCategoryFrame',
  components: { EllipsisMenu },
  props: {
    fileCategoryData: {
      type: Object,
      default: () => ({}),
    },
    filesData: {
      type: Array,
      default: () => [],
    },
    active: Boolean,
    isEditable: Boolean,
  },
  data() {
    return {
      dragEntered: false,
    };
  },
  computed: {
    filesStorageSize() {
      const size = this.filesData.reduce((acc, current) => acc + current.file.size, 0);
      return utils.storageSizeCounter(size);
    },
    filesWord() {
      return utils.pluralWord(this.filesData.length, 'файл', 'файла', 'файлов');
    },
    menuItems() {
      return [
        { text: 'Переименовать', icon: 'edit', handler: () => { this.$emit('rename'); } },
        { text: 'Удалить', icon: 'archive', handler: () => { this.$emit('delete'); } },
      ];
    },
  },
  methods: {
    fileDragEnter() {
      if (this.fileCategoryData['@id']) {
        this.dragEntered = true;
      }
    },
    fileDragLeave() {
      this.dragEntered = false;
    },
    fileDrop() {
      this.dragEntered = false;
      this.$emit('fileDrop');
    },
  },
};
</script>

<style scoped lang="scss">
  .project-file-category-frame {
    box-sizing: border-box;
    width: 248px;
    height: 52px;
    cursor: pointer;
    user-select: none;
    border-radius: 6px;
    position: relative;
    padding: 8px 11px 8px 14px;
    border: 1px solid transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__common {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 36px;
    }

    &__name {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: var(--color-dark-gray);
    }

    &__length {
      font-style: normal;
      font-weight: 400;
      font-size: 11px;
      line-height: 14px;
      color: var(--color-middle-gray);
    }

    &__size {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      color: var(--color-accent);
    }

    &__menu {
      display: none;
    }

    &:hover &__menu {
      display: block;
      position: absolute;
      right: 15px;
      z-index: 10;
    }

    &.isEditable:hover &__size {
      display: none;
    }

    &:before {
      display: block;
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      height: 100%;
      background-color: #C4C4C4;
      border-radius: 6px 0 0 6px;
    }

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &.active {
      background-color: #EFF7FF;
    }

    &:hover, &.dragEntered {
      border: 1px solid #FED56D
    }
  }

</style>
